// eslint-disable-next-line import/prefer-default-export
export const setInputBackgroundColor = ({ dailyWorkReport }) => {
  if (
    dailyWorkReport.colores === '#FFFFFF,#219E66' ||
    dailyWorkReport.colores === '#219E66,#FFFFFF'
  )
    return 'backgroundGreen';
  if (
    dailyWorkReport.colores === '#FFFFFF,#159AD8' ||
    dailyWorkReport.colores === '#159AD8,#FFFFFF'
  )
    return 'backgroundBlue';
  if (
    dailyWorkReport.colores === '#FFFFFF,#FF6666' ||
    dailyWorkReport.colores === '#FF6666,#FFFFFF'
  )
    return 'backgroundRed';

  return 'transparent';
};
